// image
import DpubHeadImage from '@didi/dpub-widget/dist/components/DpubHeadImage/index.js'
import DpubContentImage from '@didi/dpub-widget/dist/components/DpubContentImage/index.js'
import DpubSlider from '@didi/dpub-widget/dist/components/DpubSlider/index.js'
import DpubHotAreaImage from '@didi/dpub-widget/dist/components/DpubHotAreaImage/index.js'
import '@didi/dpub-widget/dist/components/DpubSlider/index.css'
import '@didi/dpub-widget/dist/components/DpubImage/index.css'

// button
import DpubButton from '@didi/dpub-widget/dist/components/DpubButton/index.js'
// import '@didi/dpub-widget/dist/components/DpubButton/index.css'

// text
import DpubText from '@didi/dpub-widget/dist/components/DpubText/index.js'
import DpubHeadTitle from '@didi/dpub-widget/dist/components/DpubHeadTitle/index.js'
import DpubThirdTitle from '@didi/dpub-widget/dist/components/DpubThirdTitle/index.js'
import DpubSecondTitle from '@didi/dpub-widget/dist/components/DpubSecondTitle/index.js'
import DpubPrimaryText from '@didi/dpub-widget/dist/components/DpubPrimaryText/index.js'
import DpubIcon from '@didi/dpub-widget/dist/components/DpubIcon/index.js'
import DpubSecondText from '@didi/dpub-widget/dist/components/DpubSecondText/index.js'
import DpubThirdText from '@didi/dpub-widget/dist/components/DpubThirdText/index.js'
import DpubGroup from '@didi/dpub-widget/dist/components/DpubGroup/index.js'
import '@didi/dpub-widget/dist/components/DpubText/index.css'
// import '@didi/dpub-widget/dist/components/DpubIcon/index.css'


// vedio
import DpubVideo from '@didi/dpub-widget/dist/components/DpubVideo/index.js'
import '@didi/dpub-widget/dist/components/DpubVideo/index.css'

// audio
import DpubBgm from '@didi/dpub-widget/dist/components/DpubBgm/index.js'
import '@didi/dpub-widget/dist/components/DpubBgm/index.css'


export const dpubComps = {
  DpubHeadImage,
  DpubContentImage,
  DpubSlider,
  DpubHotAreaImage,
  DpubButton,
  DpubText,
  DpubHeadTitle,
  DpubSecondTitle,
  DpubThirdTitle,
  DpubPrimaryText,
  DpubIcon,
  DpubSecondText,
  DpubThirdText,
  DpubGroup,
  DpubVideo,
  DpubBgm
}
